import { FormEvent, useEffect, useState } from 'react'
import style from './register.module.scss'
import { Link, useNavigate } from 'react-router'
import { useRegisterMutation } from 'src/redux/Api/authApi'
import { useDispatch } from 'react-redux'
import { setParams } from 'src/redux/Slices/configSlice'
import { setCredentials } from 'src/redux/Slices/authSlice'
import Input from 'src/Components/Form/Input'
import { useCheckForm } from 'src/utils/Hooks/useCheckForm'
import GoogleAuth from 'src/Components/GoogleAuth'

const Register = () => {
  const checkForm = useCheckForm()
  const dispatch = useDispatch()
  const [register] = useRegisterMutation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [matchPwd, setMatchPwd] = useState('')
  const [validMatch, setValidMatch] = useState(false)

  useEffect(() => {
    const match = password === matchPwd && password.length !== 0
    setValidMatch(match)
  }, [password, matchPwd])

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const check = checkForm(e)
    if (!check) {
      dispatch(setParams({ status: 'warning', message: 'Fill in required fields' }))
      return
    }
    if (!validMatch) {
      dispatch(setParams({ status: 'error', message: 'Passwords don`t match' }))
      return
    }
    if (password.length < 8) {
      dispatch(setParams({ status: 'warning', message: 'Password min length 8 characters' }))
      return
    }

    const response = await register({ email, password }).unwrap()
    dispatch(setParams(response))
    dispatch(setCredentials(response.data))
    navigate('/', { replace: true })
  }

  return (
    <section className={style.registration}>
      <h1 className="main_title">Registration</h1>
      <form onSubmit={handleSubmit} className="block">
        <Input type="email" name="email" label="Email" onChange={(e) => setEmail(e.target.value)} required value={email} />
        <Input onChange={(e) => setPassword(e.target.value)} type="password" name="pwd" label="Password" required value={password} />
        <Input
          onChange={(e) => setMatchPwd(e.target.value)}
          type="password"
          name="matchPwd"
          label="Confirm password"
          required
          value={matchPwd}
        />
        <button type="submit" className="btn">
          Sign Up
        </button>
        <GoogleAuth />
      </form>
      <p>
        Already registered?
        <br />
        <Link to="/login">Sign In</Link>
      </p>
    </section>
  )
}

export default Register
